module.exports = __webpack_public_path__ + "img/restaurant1.1a269342.png";